export const ARROW_DOWN = 'arrowDown';
export const CAMERA = 'camera';
export const CHECK = 'check';
export const CROSS = 'cross';
export const CROSS_LARGE = 'crossLarge';
export const DELETE = 'delete';
export const EXPAND = 'expand';
export const HEALTH_CHECK = 'healthCheck';
export const HOUSE = 'house';
export const MAP = 'map';
export const PLUS = 'plus';
export const SEARCH = 'search';
export const STATUS_ERROR = 'statusError';
export const STATUS_OK = 'statusOk';
export const USER = 'user';
export const PDF = 'pdf';
export const SWITCH2 = 'switch2';
